export interface CasePresentation {
  brand: string;
  theme: string;
  contactPhone: string;
  contactPagePhone: string;
  noEventContactPhone: string;
  claimLink: string;
  abroadInfoLink: string;
}

export interface Case {
  mobileNoCountry: string;
  incidentDateTime: string;
  presentation: CasePresentation;
  actions: CaseAction[];
}

export interface CaseAction {
  createdDateTime: string;
  caseActionType: CaseActionTypeEnum;
  events: CaseActionEvent[];
}

export enum CaseActionTypeEnum {
  unknown = 0,
  towing = 1,
  notification = 2,
}

export interface CaseActionEvent {
  eventType: CaseActionEventTypeEnum;
  eventDateTime: string;
  etaMinutes: number;
}

export enum CaseActionEventTypeEnum {
  Unknown = 0,
  CaseRegistered = 1,
  TowingRequested = 2,
  DispatchedAccepted = 3,
  OnTheWay = 4,
  ArrivalAtIncidentSite = 5,
  ReadyAtIncidentSite = 6,
  StartTransportation = 7,
  ReadyAtDestination = 8,
  ServiceExecuted = 9,
  Cancelled = 10,
  Interrupted = 11,
}

export function toCustomerCase(value: unknown): Case {
  const data = value as Case;
  if (!data || typeof data.mobileNoCountry !== "string" ||
      typeof data.incidentDateTime !== "string" || !data.presentation ||
      !/^[a-z][a-z0-9-]*$/.test(data.presentation.brand) ||
      !/^[a-z][a-z0-9-]*$/.test(data.presentation.theme) ||
      typeof data.presentation.contactPhone !== "string" ||
      typeof data.presentation.contactPagePhone !== "string" ||
      typeof data.presentation.noEventContactPhone !== "string" ||
      typeof data.presentation.claimLink !== "string" ||
      typeof data.presentation.abroadInfoLink !== "string" ||
      !Array.isArray(data.actions)) {
    throw new Error("Invalid customer status");
  }

  return {
    mobileNoCountry: data.mobileNoCountry,
    incidentDateTime: data.incidentDateTime,
    presentation: {
      brand: data.presentation.brand,
      theme: data.presentation.theme,
      contactPhone: data.presentation.contactPhone,
      contactPagePhone: data.presentation.contactPagePhone,
      noEventContactPhone: data.presentation.noEventContactPhone,
      claimLink: data.presentation.claimLink,
      abroadInfoLink: data.presentation.abroadInfoLink,
    },
    actions: data.actions.map(action => {
      if (!action || typeof action.createdDateTime !== "string" ||
          typeof action.caseActionType !== "number" || !Array.isArray(action.events)) {
        throw new Error("Invalid customer status");
      }
      return {
        createdDateTime: action.createdDateTime,
        caseActionType: action.caseActionType,
        events: action.events.map(event => {
          if (!event || typeof event.eventType !== "number" ||
              typeof event.eventDateTime !== "string" ||
              typeof event.etaMinutes !== "number") {
            throw new Error("Invalid customer status");
          }
          return {
            eventType: event.eventType,
            eventDateTime: event.eventDateTime,
            etaMinutes: event.etaMinutes,
          };
        }),
      };
    }),
  };
}
